import React, { useState } from "react";
import axios from 'axios';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import { ClinicServiceOption } from './ClinicServiceOption';

export const ClinicServiceSelectForm = (props) => {
  const { init_clinic_service, options } = props;
  const [currentSelect, setCurrentSelect] = useState(init_clinic_service);

  const notify = (type, message) => {
    if (type === "success") {
      toast.success(message, {
        hideProgressBar: true
      });
    } else {
      toast.error(message, {
        hideProgressBar: true
      });
    }
  }

  const onChangeEnabled = () => {
    setCurrentSelect({
      ...currentSelect,
      enabled: !currentSelect.enabled,
    })
  }

  const onChangeData = (e) => {
    setCurrentSelect({
      ...currentSelect,
      [e.target.name]: e.target.value,
    })
  };

  const onClickClinicServiceSelectUpdate = () => {
    var data = {
      clinic_service: {
        enabled: currentSelect.enabled,
        base_price: parseInt(currentSelect.base_price, 10),
        select_barium_price: parseInt(currentSelect.select_barium_price, 10),
        select_mouth_price: parseInt(currentSelect.select_mouth_price, 10),
        select_nose_price: parseInt(currentSelect.select_nose_price, 10),
      },
      id: currentSelect.id,
    };

    // axios csrfToken
    const csrfToken = document.querySelector('[name=csrf-token]').content
    axios.defaults.headers.common['X-CSRF-Token'] = csrfToken

    axios.patch(`/api/v1/clinic_services/${currentSelect.id}`, data)
    .then(resp => {
      console.log("ClinicServiceSelect Update api ok");
      console.log(resp.data);
      notify("success", "ClinicServiceSelect Update Success!");
    })
    .catch(e => {
      console.log("ClinicServiceSelect Update api ng");
      console.log(e.response);
      setCurrentSelect({ 
        ...currentSelect,
        enabled: init_clinic_service.enabled,
        base_price: init_clinic_service.base_price,
        select_barium_price: init_clinic_service.select_barium_price,
        select_mouth_price: init_clinic_service.select_mouth_price,
        select_nose_price: init_clinic_service.select_nose_price,
      });
      alert(JSON.parse(e.request.responseText).errors);
      notify("error", "ClinicServiceSelect Update Error!");
    });
  }

  return (
    <>
      <div className="accordion-item">
        <h2 className="accordion-header" id="panelsStayOpen-headingSelect">
          <button className="accordion-button" type="button" data-bs-toggle="collapse" data-bs-target="#panelsStayOpen-collapseSelect" aria-expanded="true" aria-controls="panelsStayOpen-collapseSelect">
            セレクト健診
          </button>
        </h2>
        <div id="panelsStayOpen-collapseSelect" className="accordion-collapse collapse show" aria-labelledby="panelsStayOpen-headingSelect">
          <div className="accordion-body">
            <div className="row">
              <div className="col mb-3">
                <div className="form-check form-switch">
                  <input className="form-check-input" type="checkbox" id="flexSwitchCheckCheckedSelect" checked={currentSelect.enabled} onChange={onChangeEnabled} />
                  <label className="form-check-label" htmlFor="flexSwitchCheckCheckedSelect">セレクト健診可能</label>
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col col-md-4 col-sm-12">
                <div className="input-group mb-3">
                  <span className="input-group-text" id="title-basic-base_price">基本料金</span>
                  <input type="number" name="base_price" className="form-control" id="basic-base_price" value={currentSelect.base_price || ''} onChange={onChangeData} />
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-4">
                <div className="input-group mb-3">
                  <span className="input-group-text" id="title-basic-select_barium_price">バリウム</span>
                  <input type="number" name="select_barium_price" className="form-control" id="basic-select_barium_price" value={currentSelect.select_barium_price || ''} onChange={onChangeData} />
                </div>
              </div>
              <div className="col-4">
                <div className="input-group mb-3">
                  <span className="input-group-text" id="title-basic-select_mouth_price">経口内視鏡</span>
                  <input type="number" name="select_mouth_price" className="form-control" id="basic-select_mouth_price" value={currentSelect.select_mouth_price || ''} onChange={onChangeData} />
                </div>
              </div>
              <div className="col-4">
                <div className="input-group mb-3">
                  <span className="input-group-text" id="title-basic-select_nose_price">経鼻内視鏡</span>
                  <input type="number" name="select_nose_price" className="form-control" id="basic-select_nose_price" value={currentSelect.select_nose_price || ''} onChange={onChangeData} />
                </div>
              </div>
            </div>

            <div className="d-grid gap-2 col-3 mx-auto">
              <button 
                className="btn btn-primary" 
                type="button"
                onClick={onClickClinicServiceSelectUpdate}
              >
                内容更新
              </button>
            </div>

            <hr />

            <ClinicServiceOption init_clinic_service={init_clinic_service} options={options} />
          </div>
        </div>
      </div>
    </>
  );
};